var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoucher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "coupon-star",
    d: "m21 10v-3a2.652 2.652 0 0 0 -3-3h-12a2.652 2.652 0 0 0 -3 3v3a2 2 0 0 1 0 4v3a2.652 2.652 0 0 0 3 3h12a2.652 2.652 0 0 0 3-3v-3a2 2 0 0 1 0-4zm-4.894 1.488-1.53 1.48a.47.47 0 0 0 -.137.417l.351 2.026a.505.505 0 0 1 -.734.53l-1.836-.957a.475.475 0 0 0 -.44 0l-1.834.956a.506.506 0 0 1 -.735-.531l.35-2.024a.47.47 0 0 0 -.137-.417l-1.53-1.48a.469.469 0 0 1 .262-.8l2.116-.3a.473.473 0 0 0 .357-.257l.917-1.843a.507.507 0 0 1 .908 0l.917 1.843a.473.473 0 0 0 .357.257l2.116.3a.469.469 0 0 1 .262.8z",
    fill: "#1c4b3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucher);
export default __webpack_public_path__ + "static/media/voucher.c563d3cbcec2efe4b3e3a9f43e3e590e.svg";
export { ForwardRef as ReactComponent };